<div [formGroup]="parentFormGroup()">
  <div class="gy-4" style="display: flex; flex-direction: column; gap: 10px">
    <!-- Street Number & Direction, e.g.: 500 West -->
    <div class="row gx-2">
      <div class="col-8">
        <input [formControlName]="streetNumber()"
               class="form-control"
               type="number"
               placeholder="{{'ContactAssessor.AddNumber' | translate}}">
      </div>
      <div class="col-4">
        <select [formControlName]="streetDirection()"
                class="form-select">
          <option selected value="">{{ 'ContactAssessor.AddDirection' | translate }}..</option>
          <option>North</option>
          <option>West</option>
          <option>South</option>
          <option>East</option>
        </select>
      </div>
    </div>
    <!-- Street Name & Type, e.g. Temple St. -->
    <div class="row gx-2">
      <div class="col-6">
        <input [formControlName]="streetName()"
               class="form-control"
               type="text"
               placeholder="{{'ContactAssessor.AddStreet' | translate}}">
      </div>
      <!-- Unit Number -->
      <div class="col-2">
        <input [formControlName]="unitNumber()"
               class="form-control col-12 col-md-6"
               type="text"
               placeholder="{{'ContactAssessor.AddUnit' | translate}}">
      </div>
      <div class="col-4">
        <select [formControlName]="streetType()"
                class="form-select">
          <option selected value="">Type..</option>
          <option>Dr</option>
          <option>St</option>
          <option>Ave</option>
        </select>
      </div>
    </div>
    <!-- City & Zip -->
    <div class="row gx-2">
      <div class="col-6">
        <input [formControlName]="city()"
               type="text"
               class="form-control"
               placeholder="{{'ContactAssessor.AddCity' | translate}}">
      </div>
      <div class="col-6">
        <input [formControlName]="zipCode()"
               type="text"
               class="form-control"
               placeholder="{{'ContactAssessor.AddZip' | translate}}">
      </div>
    </div>
  </div>
</div>
